export function init_sizeguide() {

    // Reveal sizeguide image
    const SIZEGUIDE_LINK = document.querySelector('.sizeguide-link');
    const SIZEGUIDE_IMG = document.querySelector('.sizeguide-img');

    if (SIZEGUIDE_LINK && SIZEGUIDE_IMG) {
        SIZEGUIDE_LINK.addEventListener('click', function (e) {
            SIZEGUIDE_IMG.classList.toggle('visible');
            e.preventDefault();
        });
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/scripts/sizeguide.js